import {keyframes} from '@emotion/react';
import styled from '@emotion/styled';

const rotating = keyframes`
from {
  transform: rotate(0deg);
}

to {
  transform: rotate(360deg);
}
`;

export const AnimationWrapper = styled.div`
  grid-column-start: 1;
  grid-row-start: 1;
  justify-self: center;
  display: flex;
  align-items: center;

  svg {
    animation: ${rotating} 2s linear infinite;
    transform-origin: 50% 50%;
    display: inline-block;
  }
`;
